import {z} from 'zod';

export const EMAIL_PASSWORD_POLICY = Object.freeze({
  minLength: 12, maxLength: 128, maxBytes: 512, emailMaxLength: 254,
  setupTtlSeconds: 1800, attemptWindowSeconds: 900, maxAttempts: 10, maxPeerAttempts: 100,
  maxConcurrentDerivations: 8
});

export const EmailSchema = z.string().trim().toLowerCase().max(EMAIL_PASSWORD_POLICY.emailMaxLength).pipe(z.email());
export const PasswordSchema = z.string().min(EMAIL_PASSWORD_POLICY.minLength).max(EMAIL_PASSWORD_POLICY.maxLength)
  .refine(value => new TextEncoder().encode(value).length <= EMAIL_PASSWORD_POLICY.maxBytes,
    'The password is too long in bytes.');
export const PasswordCredentialsSchema = z.object({email: EmailSchema, password: PasswordSchema}).strict();
// Older open pages can send a plan hint. Registration does not activate or save it.
export const PasswordRegistrationSchema = PasswordCredentialsSchema.extend({planId: z.uuid().optional()}).strict();
export const LoginSetupSchema = PasswordCredentialsSchema.extend({token: z.string().regex(/^[0-9a-f]{64}$/)}).strict();
